import * as React from "react";
const SvgX16 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M12.396 13.104a.5.5 0 0 0 .708-.708L8.707 8l4.397-4.396a.5.5 0 0 0-.708-.708L8 7.293 3.604 2.896a.5.5 0 1 0-.708.708L7.293 8l-4.397 4.396a.5.5 0 0 0 .708.708L8 8.707l4.396 4.397Z" }));
const ForwardRef = React.forwardRef(SvgX16);
export default ForwardRef;
